/**
 *
 * Use the Google Tag Manager dataLayer to track Google Analytics events
 * when DOM events are triggered on HTML elements
 *
 * How to use ?
 * 1. Make sure to load Google Tag Manager
 * 2. Equip your HTML element with a data attribute named data-gtmev
 * 3. Set the value of data-gtmev to any JS event supported by jQuery (click, mousein, focus, change, ...)
 * 4. Equip your HTML element with a data attribute named data-gtmevdata
 * 5. Set the value of data-gtmevdata to a JSON string with one or more Google Analytics custom event params
 *
 * Example HTML element
 * <a href="#" data-gtmev="click" data-gtmevdata='{eventCategory:"Videos", eventAction:"Play", eventLabel:"Cat fail compilation", eventValue:"0"}'>Click to play video</a>
 *
 */

// TODO Add support to track new dynamically added elements

var ValueJS = ValueJS || {};

ValueJS.GTM = ValueJS.GTM || {};

ValueJS.GTM.Events = function() {

    var _config = {
      gtmCustomEventName : 'GACustomEvent'    // name of custom event in GTM to trigger
    };

    var _init = function() {
      _trackStandardEvents();
    }

    var _trackStandardEvents = function() {
      $('*[data-gtmev]').each(function() {
        var el = $(this);
        el.on(el.data('gtmev'), function() {
          _track(el.data('gtmevdata'));
        });
      });
    }

    var _track = function(eventData) {
      eventData.event = _config.gtmCustomEventName;
      if (ValueJS.debug) {
        _debug(eventData, 'Custom GTM event triggered.');
      } else {
        if (window.dataLayer) {
          dataLayer.push(eventData);
        } else {
          _debug(eventData, 'Custom GTM event triggered but dataLayer not found.');
        }
      }
    }

    var _debug = function(data, msg) {
      console.log(msg);
      console.dir(data);
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
        track : function(eventData) {return _track(eventData);},
    };

}();

$(function() {
  ValueJS.GTM.Events.init();
});
